import React, { Component } from 'react';
import { connect } from "react-redux";
import PHReportSettingsView from './patient-hours';
import WageParityReportSettings from './wage-parity';
import CertifiedPayrollReportSettings from './certified-payroll';
import NJCertifiedSettings from './nj-certified';
import PPDSettings from "./ppd";
import CountersTEReportSettings from './countersTEReportSettings';
class ReportSettingsView extends Component {

  isPermission(key) {
    return this.props.CLIENT_PERMISSIONS?.find(p => p.key === key && p.isActive);
  }

  render() {
    return (
      <>
        <div className="reportList">

          {this.isPermission('PatientReducer') && (
            <PHReportSettingsView></PHReportSettingsView>
          )}
          {this.isPermission('WAGE_PARITY') && (
            <WageParityReportSettings></WageParityReportSettings>
          )}
          {this.isPermission('CERTIFIED_PAYROLL') && (
            <CertifiedPayrollReportSettings></CertifiedPayrollReportSettings>
          )}
          {this.isPermission('NJ_CERTIFIED') && (
            <NJCertifiedSettings></NJCertifiedSettings>
          )}
          {this.isPermission('PPD_CENSUS_DATA') && (
            <PPDSettings></PPDSettings>
          )}
          {this.isPermission('COUNTERS_TE_REPORT') && (
            <CountersTEReportSettings></CountersTEReportSettings>
          )}
        </div>
      </>
    );
  }
};

const mapStateToProps = ({ UserReducer, ClientDataReducer, PatientReducer, PermissionReducer, SavedECReducer, EINReducer }) => {
  const { CLIENT_PERMISSIONS } = PermissionReducer;
  const { PHRS, } = PatientReducer;
  const { EINS } = EINReducer;
  return { UserReducer, ClientDataReducer, CLIENT_PERMISSIONS, PHRS, EINS, SavedECReducer };
};

export default connect(mapStateToProps, {
})(ReportSettingsView);




